export const destinationGroupsKeys = {
  all: ['destination-groups'],
  lists: () => [...destinationGroupsKeys.all, 'list'],
  list: (page: number, perPage: number) => [...destinationGroupsKeys.lists(), { page, perPage }],
  details: () => [...destinationGroupsKeys.all, 'detail'],
  detail: (id: number) => [...destinationGroupsKeys.details(), { id }],
} as const;
